export default {
    section: 'Adjustment Mechanism',
    name: 'offer-letter-adjustment-mechanism',
    items: [
        {
            type: 'selectlist',
            text: 'Type',
            name: 'offer-letter-adjustment-mechanism-type',
            width: 3,
            props: {
                items: [
                    // TODO: Get Adjustment Mechanism Type Values
                    {
                        text: 'swap-adjustment-mechanisms',
                        value: 'swap-adjustment-mechanisms'
                    }
                ]
            }
        },
        {
            type: 'datepicker',
            // TODO: Verify if this is a datepicker or a timeframe (e.g. 5 years, 30 days, etc)
            text: 'Adjustment Date',
            name: 'offer-letter-adjustment-mechanism-date',
            width: 3,
            props: {}
        },
        {
            type: 'text-field',
            text: 'Retained Amount (No Adjustment)',
            name: 'offer-letter-adjustment-mechanism-retained',
            width: 3,
            props: {
                label: 'Retained Amount',
                format: 'percent'
            }
        },
        {
            type: 'datepicker',
            text: 'Early Release Date',
            name: 'offer-letter-adjustment-mechanism-early-release',
            width: 3,
            props: {}
        },
        {
            type: 'textarea',
            text: 'Notes',
            name: 'offer-letter-adjustment-mechanism-notes',
            props: {}
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/offer-letter/valuation-data/adjustment-mechanism.js